import {
  invoiceRelatedL4Codes,
  lateDeliveryIssueCodes,
  productDamageCodes,
  shippingIssueCodes,
} from './../shared/helpers/case-helpers';
import { isEmpty, includes } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService } from '@spartacus/core';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { KnBrQuotesService } from 'src/app/store/kn-br-quotes/kn-br-quotes.service';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { KnBrCustomerContextService } from '../store/kn-br-customer-context/kn-br-customer-context.service';
import { RemoveLeadingZerosPipe } from 'src/app/shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import {
  conductCodes,
  invoiceRelatedL3Codes,
  wrongQtyCodes,
  productDefectSubCodes,
  earlyDeliveryIssueCodes,
} from '../shared/helpers/case-helpers';
import {
  KNBR_CASE_CREATE,
  KNBR_CASE_CREATE_UPLOAD_FILE,
  KNBR_GET_ALTERNATE_UOMS,
  KNBR_GET_CASE_TYPES,
  KNBR_GET_FREIGHT_CLAIM_DETAILS,
  KNBR_GET_INFO_TO_CREATE_CASE,
  KNBR_GET_INVOICE_INFO_TO_CREATE_CASE,
  KNBR_GET_ISSUE_SUB_TYPES,
  KNBR_GET_ISSUE_TYPES,
  KNBR_GET_PRODUCTS,
  KNBR_GET_PRODUCTS_FROM_INVOICE,
  KNBR_GET_SHIPMENTS_FROM_INVOICE,
  KNBR_GET_SKU_SUGGESTIONS_TO_CREATE_CASE,
  KN_BR_CUSTOMER_CURRENT,
} from 'src/constants/api.endpoints.constant';
import { CAST_TYPES_BACKUP } from 'src/constants/pagination.constant';
import { KnBrDateHelper } from '../shared/kn-br-date.helper';
import moment from 'moment';
import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';
import { Location, NgClass, AsyncPipe, SlicePipe } from '@angular/common';
import { Observable, of, Subscription } from 'rxjs';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { NgSelectComponent, NgOptionTemplateDirective, NgMultiLabelTemplateDirective } from '@ng-select/ng-select';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'kn-br-case-create',
    templateUrl: './kn-br-case-create.component.html',
    styleUrls: ['./kn-br-case-create.component.scss'],
    providers: [RemoveLeadingZerosPipe],
    imports: [
        ReactiveFormsModule,
        NgSelectComponent,
        NgbInputDatepicker,
        NgOptionTemplateDirective,
        FormsModule,
        NgMultiLabelTemplateDirective,
        NgClass,
        AsyncPipe,
        SlicePipe,
    ],
})
export class KnBrCaseCreateComponent implements OnInit, OnDestroy {
  public formGroup: FormGroup;
  displayinitialMainDropdown = true;
  orderUrlObject;
  invoiceUrlObject;
  orderNumber;
  jobName;
  salesArea;
  salesGroup;
  salesOffice;
  salesUnit;
  defaultQuantityValue = '';
  currentDateValue = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  uploadedFileObjects = [];
  todayDate = () => ({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  });
  maxStartDate = () => this.todayDate();
  customerId: string;
  caseCreationForm: UntypedFormGroup;
  helperForm: UntypedFormGroup;
  caseTypesData = [];
  issueTypesData = [];
  issueSubTypesData = [];
  productsData = [];
  showAdditionalDetails = false;

  selectedCaseType: any;
  selectedIssueType: any;
  selectedIssueSubType: any;

  showIssueType = false;
  showIssueSubType = false;
  showIncidentDate = false;
  showCaseDesc = false;
  showProducts = false;
  showMultiSelectProducts = false;
  showBatchNumber = false;
  showQuantity = false;
  showRequestedSku = false;
  showDeliveredSku = false;
  showShipmentNumber = false;
  shipmentResponseData: { name: any; value: string }[];
  showUploadFileSection = false;
  submitted: boolean = false;
  multipleSelectedProducts = [];
  showSpinner: any;
  caseFromInvoice = false;
  allApiSubscriptions = new Subscription();
  alternateUomData = {};
  options$: Observable<string[]>;
  selectedDeliveredSkuName;
  selectedRequestedSkuEntryNumber;
  isDragOver: boolean = false;
  invoicesForTheOrder: any = [];
  showClaimCheckbox = false;
  showClaimForm: boolean = false;

  yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  claimStatusOptions = [
    { label: 'Open', value: 'OPEN' },
    { label: 'Settle', value: 'SETTLE' },
    { label: 'Closed', value: 'CLOSED' },
  ];

  constructor(
    protected fb: UntypedFormBuilder,
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCommonService: KnBrCommonService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected removeLeadingZerosPipe: RemoveLeadingZerosPipe,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient,
    private endPointService: OccEndpointsService,
    protected cdr: ChangeDetectorRef,
    protected routingService: RoutingService,
    private knBrDateHelper: KnBrDateHelper,
    protected globalMessageService: GlobalMessageService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected router: Router,
    protected _location: Location
  ) {
    setTimeout(() => {
      this.options$ = this.caseCreationForm?.get('deliveredSku')?.valueChanges.pipe(
        debounceTime(300),
        switchMap((value) => this.fetchOptions(value))
      );
    }, 2000);
  }

  ngOnInit(): void {
    if (this.router.url.includes('/invoice')) {
      this.caseFromInvoice = true;
    }
    this.initForm();
    this.allApiSubscriptions.add(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (this.caseFromInvoice) {
          this.invoiceUrlObject = {
            documentNumber: params['documentNumber'] || null,
            matPosNo: params['matPosNo'] || '',
          };
          this.invoiceUrlObject = this.removeEmptyEntriesfromObject(this.invoiceUrlObject);
        } else {
          this.orderUrlObject = {
            orderNumber: params['orderNumber'] || null,
            materialNumber: params['materialNumber'] || '',
            entryNumber: params['entryNumber'] || '',
          };
          this.orderUrlObject = this.removeEmptyEntriesfromObject(this.orderUrlObject);
        }
        this.getJobInfoAndCaseTypes();
      })
    );

this.caseCreationForm
  .get('fileDate')!
  .valueChanges.pipe(
    distinctUntilChanged(
      (prev, curr) => prev?.year === curr?.year && prev?.month === curr?.month && prev?.day === curr?.day
    )
  )
  .subscribe((value) => {
    if (value) {
      const days = this.calculateDays(value);
      this.caseCreationForm.get('noOfDaysPassed').patchValue(days, { emitEvent: false });
    } else {
      this.caseCreationForm.get('noOfDaysPassed').patchValue('', { emitEvent: false });
    }
  });

  }

  calculateDays(date: any): number {
  const selected = new Date(date.year, date.month - 1, date.day);
  const today = new Date();

  selected.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffMs = today.getTime() - selected.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

  getJobInfoAndCaseTypes() {
    this.allApiSubscriptions.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
        this.getJobNameResponse();
        this.getCaseTypesData();
      })
    );
  }

  initForm() {
    this.helperForm = this.fb.group({
      orderBaseDocumentNumber: [null],
      proxyCaseType: [null, Validators.required],
    });

    this.caseCreationForm = this.fb.group(
      {
        uom: [null],
        caseType: [null],
        salesArea: [null],
        salesGroup: [null],
        salesOffice: [null],
        salesUnit: [null],
        orderNumber: [null],
        documentNumber: [null],
        issueType: [{ value: null, disabled: true }, Validators.required],
        issueSubType: [{ value: null, disabled: true }, Validators.required],
        caseDescription: [{ value: null, disabled: true }, [Validators.required, Validators.maxLength(512)]],
        incidentDate: [{ value: null, disabled: true }],
        products: [{ value: null, disabled: true }],
        multiSelectProducts: [{ value: null, disabled: true }],
        batchNumber: [{ value: null, disabled: true }],
        quantity: [{ value: null, disabled: true }],
        requestedSku: [{ value: null, disabled: true }, Validators.required],
        deliveredSku: [{ value: null, disabled: true }, Validators.required],
        invoiceNumber: [{ value: null, disabled: true }],
        shipmentNumber: [{ value: null, disabled: true }],
        fileInput: [''],
        fileFreightClaim: [],
        Plant: [{ value: null, disabled: true }],
        ShipDate: [{ value: null, disabled: true }],
        CarrierName: [{ value: null, disabled: true }],
        CarrierNumber: [{ value: null, disabled: true }],
        DestCity: [{ value: null, disabled: true }],
        DestState: [{ value: null, disabled: true }],
        DestZipcode: [{ value: null, disabled: true }],
        claimAmount: [{ value: null, disabled: true }],
        contact: [null],
        claimStatus: [null],
        claimNumber: [null],
        damageClaim: [null],
        lossClaim: [null],
        fileDate: [null],
        settleOrDeclineDate: [null],
        settleAmount: [null],
        remark: [null],
        plantOwner: [null],
        noOfDaysPassed: [{ value: null, disabled: true }],
        checkReceivedDate: [null],
        checkNumber: [null],
      },
      {
        validators: this.fileUploadRequiredValidator(), // file upload validator
      }
    );

    this.caseCreationForm.get('issueSubType')?.valueChanges.subscribe(() => {
      this.caseCreationForm.updateValueAndValidity();
    });
  }

  getJobNameResponse() {
    let url;
    if (this.caseFromInvoice) {
      url = this.endPointService.buildUrl(KNBR_GET_INVOICE_INFO_TO_CREATE_CASE(this.customerId), {
        queryParams: this.invoiceUrlObject,
      });
    } else {
      url = this.endPointService.buildUrl(KNBR_GET_INFO_TO_CREATE_CASE(this.customerId), {
        queryParams: this.orderUrlObject,
      });
      this.helperForm.get('orderBaseDocumentNumber').setValidators([Validators.required]);
    }
    this.allApiSubscriptions.add(
      this.http.get(url).subscribe((response: any) => {
        this.orderNumber = response.orderNumber;
        this.jobName = response.jobName;
        this.salesArea = response.salesArea;
        this.salesGroup = response.salesGroup;
        this.salesOffice = response.salesOffice;
        this.salesUnit = response.salesUnit;
        this.invoicesForTheOrder = response.invoices;
        if (this.caseFromInvoice === false && response.invoices.length === 1) {
          this.helperForm.controls.orderBaseDocumentNumber.patchValue(response.invoices[0]);
        }
        this.cdr.detectChanges();
      })
    );
  }

  // CaseTypes
  getCaseTypesData() {
    const url = this.endPointService.buildUrl(KNBR_GET_CASE_TYPES(this.customerId), {
      queryParams: { filterCaseTypes: true },
    });
    this.allApiSubscriptions.add(
      this.http
        .get(url)
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
            const sortedFormat = this.knBrCommonService.alphabeticalSort(formattedResponse, 'name');
            this.caseTypesData = sortedFormat;
          },
          error: () => {
            const formattedResponse = Object.keys(CAST_TYPES_BACKUP).map((key) => ({
              name: CAST_TYPES_BACKUP[key],
              value: key,
            }));
            this.caseTypesData = formattedResponse;
          },
        })
    );
  }

  onInvoiceSelectionChange() {
    this.helperForm.get('proxyCaseType').reset();
    this.caseCreationForm.reset();
    this.disableAllFields();
  }

  // caseTypeChange
  onCaseTypeChange(selectedOption) {
    this.showIssueSubType = false;
    this.caseCreationForm.reset();
    this.showClaimCheckbox = false;
    this.showClaimForm = false;
    this.disableAllFields();
    this.submitted = false;
    this.uploadedFileObjects = [];
    this.uploadedFileObjects = [];
    this.multipleSelectedProducts = [];
    this.caseCreationForm.controls.incidentDate.patchValue(this.currentDateValue);
    this.caseCreationForm.controls.quantity.patchValue(this.defaultQuantityValue);
    if (selectedOption.value === 'ZSC2_L2_PDE' || selectedOption.value === 'ZSC2_L2_WQD') {
      this.caseCreationForm.get('multiSelectProducts').setValidators([Validators.required]);
    } else if (selectedOption.value === 'ZSC2_L2_PDA') {
      this.caseCreationForm.get('multiSelectProducts').setValidators([Validators.required]);
    } else {
      this.caseCreationForm.get('multiSelectProducts').clearValidators();
    }
    this.caseCreationForm.get('products')?.updateValueAndValidity();
    this.caseCreationForm.get('multiSelectProducts')?.updateValueAndValidity();
    this.getIssueTypesData(selectedOption.value);
    this.cdr.detectChanges();
  }

  // issueTypes
  getIssueTypesData(selectedCaseType) {
    const quantity = this.caseCreationForm.get('quantity');
    const requestedSku = this.caseCreationForm.get('requestedSku');
    const deliveredSku = this.caseCreationForm.get('deliveredSku');
    const products = this.caseCreationForm.get('products');
    const multiselectProducts = this.caseCreationForm.get('multiSelectProducts');
    const issueType = this.caseCreationForm.get('issueType');

    if (selectedCaseType) {
      this.selectedCaseType = selectedCaseType;
      const url = this.endPointService.buildUrl(KNBR_GET_ISSUE_TYPES(this.customerId));
      const urlWithParams = url + '?caseTypeCode=' + selectedCaseType;
      this.allApiSubscriptions.add(
        this.http.get(urlWithParams).subscribe((response) => {
          const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
          const sortedIssues = this.knBrCommonService.alphabeticalSort(formattedResponse, 'name');
          this.issueTypesData = sortedIssues;
          if (!isEmpty(response)) {
            this.showIssueType = true;
            issueType.enable();
          } else {
            this.showIssueType = false;
            issueType.disable();
            this.enableCommonFields();
            if (selectedCaseType === 'ZSC2_L2_WPD') {
              this.showQuantity = true;
              this.showRequestedSku = true;
              this.showDeliveredSku = true;
              this.showMultiSelectProducts = false;
              this.showAdditionalDetails = true;
              this.getProductData();
              this.knBrCommonService.enableControls([quantity, requestedSku, deliveredSku]);
            } else if (selectedCaseType === 'ZSC2_L2_PDA') {
              this.showMultiSelectProducts = true;
              this.showQuantity = false;
              this.showRequestedSku = false;
              this.showDeliveredSku = false;
              this.knBrCommonService.enableControls([multiselectProducts, products]);
              this.getProductData();
            }
          }
          this.cdr.detectChanges();
        })
      );
    }
  }

  getSingleSelectedProductValue() {
    if (this.showRequestedSku) {
      const selectedsku = this.caseCreationForm.controls['requestedSku'].getRawValue();
      return selectedsku ? selectedsku : '';
    }
    const selectedProductCode = this.caseCreationForm.controls['products'].getRawValue();
    return selectedProductCode ? selectedProductCode : '';
  }

  onProductChange() {
    this.caseCreationForm.controls['uom'].reset();
    this.getAlternateUomData();
  }

  onMultiSelectProductChange(selectedOnes) {
    this.multipleSelectedProducts = this.updateSelectedProductArrays(this.multipleSelectedProducts, selectedOnes);
    this.getAlternateUomData();
  }

  handleRequestedSkuSelection(data) {
    this.selectedRequestedSkuEntryNumber = data.entryNumber;
    this.getAlternateUomData();
  }

  getAlternateUomData() {
    if (this.multipleSelectedProducts.length) {
      this.multipleSelectedProducts.forEach((element) => {
        if (this.alternateUomData.hasOwnProperty(element.code) === false) {
          const alternateUomUrl = this.endPointService.buildUrl(
            KNBR_GET_ALTERNATE_UOMS(this.customerId, element.code, this.salesArea)
          );
          this.allApiSubscriptions.add(
            this.http.get(alternateUomUrl).subscribe((response) => {
              const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
              this.alternateUomData[element.code] = formattedResponse;
              this.cdr.detectChanges();
            })
          );
        }
      });
    } else if (this.caseCreationForm.controls['products'].getRawValue()) {
      const productCode = this.caseCreationForm.controls['products'].getRawValue();
      const alternateUomUrl = this.endPointService.buildUrl(
        KNBR_GET_ALTERNATE_UOMS(this.customerId, productCode, this.salesArea)
      );
      this.allApiSubscriptions.add(
        this.http.get(alternateUomUrl).subscribe((response) => {
          const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
          this.alternateUomData[productCode] = formattedResponse;
          this.cdr.detectChanges();
        })
      );
    } else if (this.caseCreationForm.controls['requestedSku'].getRawValue() && this.showRequestedSku) {
      const selectedsku = this.caseCreationForm.controls['requestedSku'].getRawValue();
      const alternateUomUrl = this.endPointService.buildUrl(
        KNBR_GET_ALTERNATE_UOMS(this.customerId, selectedsku, this.salesArea)
      );
      this.allApiSubscriptions.add(
        this.http.get(alternateUomUrl).subscribe((response) => {
          const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
          this.alternateUomData[selectedsku] = formattedResponse;
          this.cdr.detectChanges();
        })
      );
    }
  }

  // issueTypeChange
  onIssueTypeChange(selectedOption) {
    this.caseCreationForm.controls.issueSubType.reset();
    this.selectedIssueType = selectedOption.value;
    this.getIssueSubTypesData(selectedOption.value);
    this.clearOutSectionUponIssueTypeSelection();

    if (conductCodes.includes(this.selectedIssueType)) {
      this.conductCodeFlow();
    } else if (earlyDeliveryIssueCodes.includes(this.selectedIssueType)) {
      this.earlyDeliveryIssueCodeFlow();
    } else if (wrongQtyCodes.includes(this.selectedIssueType)) {
      this.wrongQuantityDeliveredIssueCodeFlow();
    } else if (invoiceRelatedL3Codes.includes(this.selectedIssueType)) {
      this.invoiceRelatedIssueCodeFlow();
    }
  }

  // clear out things before enable or showing below items
  clearOutSectionUponIssueTypeSelection() {
    const { multiSelectProducts, shipmentNumber } = this.caseCreationForm.controls;
    this.knBrCommonService.disableControls([multiSelectProducts, shipmentNumber]);
    this.clearOutClaimFormFields();
    this.showMultiSelectProducts = false;
    this.showShipmentNumber = false;
    this.showClaimCheckbox = false;
    this.showClaimForm = false;
    this.multipleSelectedProducts = [];
    this.disableCommonFields();
    this.resetGivenFields([multiSelectProducts, shipmentNumber]);
  }

  //case type conduct code flow
  conductCodeFlow() {
    const multiSelectProducts = this.caseCreationForm.get('multiSelectProducts');
    this.showMultiSelectProducts = true;
    this.getProductData();
    this.knBrCommonService.enableControls([multiSelectProducts]);
    this.enableCommonFields();
  }

  // case type early delivery issue code flow
  earlyDeliveryIssueCodeFlow() {
    const { shipmentNumber } = this.caseCreationForm.controls;
    this.showShipmentNumber = true;
    this.getShipmentData();
    this.knBrCommonService.enableControls([shipmentNumber]);
    this.enableCommonFields();
  }

  // case type wrong quantity issue code flow
  wrongQuantityDeliveredIssueCodeFlow() {
    const { multiSelectProducts } = this.caseCreationForm.controls;
    this.showMultiSelectProducts = true;
    this.getProductData();
    this.knBrCommonService.enableControls([multiSelectProducts]);
    this.enableCommonFields();
  }

  // case type late delivery issue code flow
  lateDeliveryIssueCodeFlow() {
    const { shipmentNumber } = this.caseCreationForm.controls;
    this.showShipmentNumber = true;
    this.getShipmentData();
    this.knBrCommonService.enableControls([shipmentNumber]);
    this.enableCommonFields();
    this.showClaimCheckbox = true;
    this.caseCreationForm.controls.fileFreightClaim.setValue(false);
  }

  // case type product damage code flow
  productDamageCodeFlow() {
    if (this.selectedIssueSubType && this.selectedIssueSubType.includes('_CDA')) {
      this.caseCreationForm.controls.fileFreightClaim.setValue(true);
      this.showClaimForm = true;
      this.showShipmentNumber = true;
      const { shipmentNumber } = this.caseCreationForm.controls;
      this.getShipmentData();
      this.knBrCommonService.enableControls([shipmentNumber]);
      let invoiceNumberSelected;
      if (this.caseFromInvoice) {
        invoiceNumberSelected = this.invoiceUrlObject?.documentNumber;
      } else {
        invoiceNumberSelected = this.helperForm.get('orderBaseDocumentNumber').value;
      }
      this.freightClaimApiToPrepopulateForm(invoiceNumberSelected);
    }
    const { multiSelectProducts } = this.caseCreationForm.controls;
    this.showMultiSelectProducts = true;
    this.getProductData();
    this.knBrCommonService.enableControls([multiSelectProducts]);
    this.enableCommonFields();
  }

  // case type product defect code flow
  productDefectCodeFlow() {
    const { multiSelectProducts, batchNumber } = this.caseCreationForm.controls;
    this.showMultiSelectProducts = true;
    this.showBatchNumber = true;
    this.getProductData();
    this.knBrCommonService.enableControls([multiSelectProducts, batchNumber]);
    this.enableCommonFields();
  }

  invoiceRelatedIssueCodeFlow() {
    const { multiSelectProducts } = this.caseCreationForm.controls;
    this.showMultiSelectProducts = true;
    this.getProductData();
    this.knBrCommonService.enableControls([multiSelectProducts]);
    this.enableCommonFields();
  }

  shippingIssueCodeFlow() {
    this.showShipmentNumber = true;
    const { shipmentNumber } = this.caseCreationForm.controls;
    this.knBrCommonService.enableControls([shipmentNumber]);
    this.enableCommonFields();
  }

  quantityChangeAfterMultiSelect(event, productObj) {
    const isNumberOnly = this.numberOnly(event);
    if (isNumberOnly) {
      productObj.quantity = event.target.value;
      this.multipleSelectedProducts = this.multipleSelectedProducts.map((item) =>
        item.code === productObj.code ? productObj : item
      );
    }
  }

  uomChangeAfterMultiSelect(selectedUom, productObj) {
    productObj.uom = selectedUom.value;
    this.multipleSelectedProducts = this.multipleSelectedProducts.map((item) =>
      item.code === productObj.code ? productObj : item
    );
  }

  numberOnly(event): boolean {
    const value = event.target.value;
    if (typeof value === 'number') {
      return false;
    }
    return true;
  }

  // subIssueTypes
  getIssueSubTypesData(selectedIssueType) {
    const issueSubType = this.caseCreationForm.controls.issueSubType;
    const url = this.endPointService.buildUrl(KNBR_GET_ISSUE_SUB_TYPES(this.customerId));
    const urlWithParams = url + '?issueTypeCode=' + selectedIssueType;
    this.allApiSubscriptions.add(
      this.http.get(urlWithParams).subscribe((response) => {
        const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
        this.issueSubTypesData = formattedResponse;
        if (this.issueSubTypesData?.length > 0) {
          this.showIssueSubType = true;
          issueSubType.enable();
        } else {
          this.showIssueSubType = false;
          issueSubType.disable();
          this.enableCommonFields();
        }
        this.cdr.detectChanges();
      })
    );
  }

  wrongQtyFields() {
    this.enableCommonFields();
    this.showMultiSelectProducts = true;
    this.caseCreationForm.get('multiSelectProducts').enable();
    this.caseCreationForm.get('quantity').enable();
    this.getProductData();
  }

  // subIssueTypeChange
  onSubIssueTypeChange(selectedOption) {
    this.selectedIssueSubType = selectedOption.value;
    this.clearOutSectionUponSubIssueTypeSelection();
    if (includes(lateDeliveryIssueCodes, this.selectedIssueSubType)) {
      this.lateDeliveryIssueCodeFlow();
    } else if (includes(productDamageCodes, this.selectedIssueSubType)) {
      this.productDamageCodeFlow();
    } else if (includes(productDefectSubCodes, this.selectedIssueSubType)) {
      this.productDefectCodeFlow();
    } else if (includes(invoiceRelatedL4Codes, this.selectedIssueSubType)) {
      this.invoiceRelatedIssueCodeFlow();
    } else if (includes(shippingIssueCodes, this.selectedIssueSubType)) {
      this.shippingIssueCodeFlow();
    }
  }

  // clear out things before enable or showing below items
  clearOutSectionUponSubIssueTypeSelection() {
    const { quantity, products, batchNumber, shipmentNumber, multiSelectProducts } = this.caseCreationForm.controls;
    this.knBrCommonService.disableControls([quantity, products, batchNumber, shipmentNumber, multiSelectProducts]);
    this.clearOutClaimFormFields();
    this.showQuantity = false;
    this.showBatchNumber = false;
    this.showShipmentNumber = false;
    this.showMultiSelectProducts = false;
    this.multipleSelectedProducts = [];
    this.showClaimCheckbox = false;
    this.showClaimForm = false;
    this.disableCommonFields();
    this.resetGivenFields([quantity, products, batchNumber, shipmentNumber, multiSelectProducts]);
    this.cdr.detectChanges();
  }

  enableCommonFields() {
    const { incidentDate, caseDescription, fileInput } = this.caseCreationForm.controls;
    this.showCaseDesc = true;
    this.showIncidentDate = true;
    this.showUploadFileSection = true;
    this.showAdditionalDetails = true;
    this.knBrCommonService.enableControls([incidentDate, caseDescription, fileInput]);
  }

  disableCommonFields() {
    const { incidentDate, caseDescription, fileInput } = this.caseCreationForm.controls;
    this.showCaseDesc = false;
    this.showIncidentDate = false;
    this.showUploadFileSection = false;
    this.showAdditionalDetails = false;
    this.knBrCommonService.disableControls([incidentDate, caseDescription, fileInput]);
  }

  resetGivenFields(formFields) {
    formFields.forEach((eachFormField) => {
      eachFormField.reset();
    });
  }
  disableAllFields() {
    this.showCaseDesc = false;
    this.showIncidentDate = false;
    this.showUploadFileSection = false;
    this.showMultiSelectProducts = false;
    this.showBatchNumber = false;
    this.showQuantity = false;
    this.showRequestedSku = false;
    this.showDeliveredSku = false;
    this.showShipmentNumber = false;
    this.showAdditionalDetails = false;

    const controls = [
      'caseDescription',
      'incidentDate',
      'products',
      'multiSelectProducts',
      'batchNumber',
      'quantity',
      'requestedSku',
      'deliveredSku',
      'shipmentNumber',
      'fileInput',
      'issueType',
      'issueSubType',
    ];

    this.knBrCommonService.disableControls(controls.map((key) => this.caseCreationForm.get(key)));
  }

  getProductData() {
    let urlWithParams;
    if (this.caseFromInvoice) {
      urlWithParams = this.endPointService.buildUrl(KNBR_GET_PRODUCTS_FROM_INVOICE(this.customerId), {
        queryParams: this.invoiceUrlObject,
      });
    } else {
      const selectedInvoice = this.helperForm.get('orderBaseDocumentNumber').value;
      urlWithParams = this.endPointService.buildUrl(KNBR_GET_PRODUCTS(this.customerId), {
        queryParams: {
          documentNumber: selectedInvoice,
          materialNumber: this.orderUrlObject.materialNumber,
          entryNumber: this.orderUrlObject.entryNumber,
        },
      });
    }
    this.allApiSubscriptions.add(
      this.http.get(urlWithParams).subscribe((response: any) => {
        if (response) {
          let products = [];
          products = response.products;
          const updatedProductsData = products.map((eachProduct) => {
            return {
              code: eachProduct.code,
              description: eachProduct.description,
              labelDescription: `${eachProduct.code} - ${eachProduct.description}`,
              quantity: '',
              entryNumber: eachProduct.entryNumber,
              uom: eachProduct.uom,
            };
          });

          this.productsData = updatedProductsData;
          if (
            (this.orderUrlObject && this.orderUrlObject.materialNumber) ||
            (this.invoiceUrlObject &&
              this.invoiceUrlObject.matPosNo &&
              this.productsData &&
              this.productsData.length === 1)
          ) {
            if (this.selectedCaseType === 'ZSC2_L2_PDA') {
              const preSelectData = [...this.productsData];
              this.caseCreationForm.controls.multiSelectProducts.patchValue(preSelectData);
              this.multipleSelectedProducts = preSelectData;
              this.getAlternateUomData();
            } else if (this.showProducts === true) {
              this.caseCreationForm.controls.products.patchValue(this.productsData[0].code);
              this.getAlternateUomData();
            }
          }
          this.cdr.detectChanges();
        }
      })
    );
  }

  // get shipment dropdown data
  getShipmentData() {
    let shipmentUrl;
    if (this.caseFromInvoice) {
      shipmentUrl = this.endPointService.buildUrl(KNBR_GET_SHIPMENTS_FROM_INVOICE(this.customerId), {
        queryParams: this.invoiceUrlObject,
      });
    } else {
      const selectedInvoice = this.helperForm.get('orderBaseDocumentNumber').value;
      shipmentUrl = this.endPointService.buildUrl(KNBR_GET_SHIPMENTS_FROM_INVOICE(this.customerId), {
        queryParams: {
          documentNumber: selectedInvoice,
        },
      });
    }
    this.allApiSubscriptions.add(
      this.http.get(shipmentUrl).subscribe((resp) => {
        const formattedResponse = Object.keys(resp).map((key) => ({ name: resp[key], value: key }));
        this.shipmentResponseData = formattedResponse;
      })
    );
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onFileSelected(event, dragFiles?) {
    this.onSpinnerLoading(true);
    const fileUploadUrl = this.endPointService.buildUrl(KNBR_CASE_CREATE_UPLOAD_FILE(this.customerId));
    const file = dragFiles ? dragFiles[0] : event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    this.allApiSubscriptions.add(
      this.http.post(fileUploadUrl, formData).subscribe(
        (response: any) => {
          this.onSpinnerLoading(false);
          if (response && response.fileReferenceId) {
            const fileSizeInBytes = file.size;
            const fileSizeInKB = fileSizeInBytes / 1024;
            const fileObj = { ...response, fileSize: fileSizeInKB.toFixed(2) };
            this.uploadedFileObjects.push(fileObj);
            this.caseCreationForm.controls['fileInput'].reset();
            this.caseCreationForm.updateValueAndValidity();
            this.cdr.detectChanges();
          } else {
            this.caseCreationForm.controls['fileInput'].reset();
            this.globalMessageService.add(
              'Something went wrong, please check the file type',
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
        },
        (error) => {
          this.globalMessageService.add('Something went wrong', GlobalMessageType.MSG_TYPE_ERROR);
          this.onSpinnerLoading(false);
          this.caseCreationForm.controls['fileInput'].reset();
        }
      )
    );
  }

  fileUploadRequiredValidator() {
    return (form: FormGroup) => {
      const issueTypeValue = form.get('issueSubType')?.value;

      const isRequired = issueTypeValue && issueTypeValue.includes('_CDA');

      // validation is based on uploaded file objects array
      if (isRequired && this.uploadedFileObjects.length < 2) {
        return { minTwoFilesRequired: true };
      }

      return null;
    };
  }

  addCustomOption(name: string): string {
    return name;
  }

  onSpinnerLoading(isLoading) {
    if (isLoading) {
      this.showSpinner = this.launchDialogService.launch(LAUNCH_CALLER.PLACE_ORDER_SPINNER, this.vcr);
    } else {
      if (this.showSpinner) {
        this.showSpinner
          .subscribe((component) => {
            this.launchDialogService.clear(LAUNCH_CALLER.PLACE_ORDER_SPINNER);
            component.destroy();
          })
          .unsubscribe();
      }
    }
  }

  goBack() {
    this.allApiSubscriptions.unsubscribe();
    if (this.caseFromInvoice) {
      this._location.back();
    } else {
      const url = 'customer-360/order/' + this.orderNumber;
      this.routingService.go(url);
    }
  }

  submitForm() {
    this.submitted = true;
    if (this.caseCreationForm.valid) {
      const form = this.caseCreationForm;
      form.patchValue({
        salesArea: this.salesArea,
        salesGroup: this.salesGroup,
        salesOffice: this.salesOffice,
        salesUnit: this.salesUnit,
        orderNumber: this.caseFromInvoice ? this.orderNumber : this.orderUrlObject.orderNumber,
        documentNumber: this.caseFromInvoice ? this.invoiceUrlObject.documentNumber : null,
        caseType: this.helperForm.controls.proxyCaseType.value,
      });
      const modifiedPayload = this.getPayloadFromForm();
      console.log('modifiedPayload', modifiedPayload);
      this.sendRequestToCreateCase(modifiedPayload);
    } else {
      this.caseCreationForm.markAllAsTouched();
    }
  }

  dateParsing(dateObj) {
    const strDate = this.knBrDateHelper.formatDate(dateObj);
    const parsedDate = moment(strDate, 'YYYYMMDD');
    const formattedDate = parsedDate.format('YYYY-MM-DDTHH:mm:ss');
    return formattedDate;
  }

  getPayloadFromForm() {
    const payload = this.caseCreationForm.getRawValue();
    const updatedPayload = { ...payload };

    // Parse date fields
    const dateFields = ['fileDate', 'incidentDate', 'shipmentDate', 'checkReceivedDate', 'settleOrDeclineDate'];
    dateFields.forEach((field) => {
      updatedPayload[field] = updatedPayload[field] ? this.dateParsing(updatedPayload[field]) : null;
    });

    updatedPayload.fileReferenceId = this.uploadedFileObjects.map((obj) => obj.fileReferenceId);
    updatedPayload.fileNames = this.uploadedFileObjects.map((obj) => obj.fileName);
    updatedPayload.jobName = this.jobName;
    updatedPayload.soldTo = this.customerId;
    if (updatedPayload.deliveredSku) {
      updatedPayload.deliveredSkuName = this.selectedDeliveredSkuName;
    } else {
      updatedPayload.deliveredSkuName = '';
    }
    if (this.multipleSelectedProducts.length && this.showMultiSelectProducts) {
      this.multipleSelectedProducts.forEach((obj) => {
        delete obj.labelDescription;
      });
      updatedPayload.products = this.multipleSelectedProducts;
      delete updatedPayload.multiSelectProducts;
    }
    if (updatedPayload.products && updatedPayload.products.length) {
      delete updatedPayload.quantity;
      delete updatedPayload.uom;
    } else if (updatedPayload.requestedSku && this.selectedCaseType === 'ZSC2_L2_WPD') {
      updatedPayload.entryNumber = this.selectedRequestedSkuEntryNumber || '';
    }

    if (this.caseFromInvoice === false) {
      updatedPayload.invoiceNumber = this.helperForm.get('orderBaseDocumentNumber')?.value;
    }
    updatedPayload.fileFreightClaim = payload.fileFreightClaim ?? false;

    delete updatedPayload.fileInput;
    return updatedPayload;
  }

  sendRequestToCreateCase(payloadData) {
    const url = this.endPointService.buildUrl(KNBR_CASE_CREATE(this.customerId));
    this.allApiSubscriptions.add(
      this.http.post(url, payloadData).subscribe((response) => {
        this.globalMessageService.add('Your case has been created.', GlobalMessageType.MSG_TYPE_CONFIRMATION);
        this.goBack();
      })
    );
  }

  removeEmptyEntriesfromObject(dataObj) {
    const dataObjNew = { ...dataObj };
    Object.keys(dataObjNew).forEach((k) => dataObjNew[k] == null && delete dataObjNew[k]);
    return dataObjNew;
  }

  removeTheSelectedItem(codeValue) {
    this.multipleSelectedProducts = this.multipleSelectedProducts.filter((obj) => obj.code != codeValue);
    this.caseCreationForm.controls.multiSelectProducts.patchValue(this.multipleSelectedProducts);
    this.cdr.detectChanges();
  }

  removeSelectedFile(fileId) {
    this.uploadedFileObjects = this.uploadedFileObjects.filter((eachObj) => eachObj.fileReferenceId != fileId);
    this.caseCreationForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  handleSelectedDeliveredsku(data) {
    this.selectedDeliveredSkuName = data.deliveredSkuName;
  }

  updateSelectedProductArrays(arrayOne, arrayTwo) {
    // Remove objects from arrayOne that are not in arrayTwo
    const filteredArrayOne = arrayOne.filter((obj1) => arrayTwo.some((obj2) => obj1.code === obj2.code));

    // Add unique objects from arrayTwo to arrayOne
    for (const obj2 of arrayTwo) {
      const existingObj = filteredArrayOne.find((obj1) => obj1.code === obj2.code);
      if (!existingObj) {
        filteredArrayOne.push(obj2);
      }
    }

    return filteredArrayOne;
  }

  getQuantityLabelName() {
    if (this.selectedCaseType === 'ZSC2_L2_PDE') {
      return 'Quantity Defective';
    } else if (this.selectedCaseType === 'ZSC2_L2_WQD') {
      if (this.selectedIssueType === 'ZSC_LIT3') {
        return 'Quantity Not Received';
      } else if (this.selectedIssueType === 'ZSC_UO3' || this.selectedIssueType === 'ZSC_US3') {
        return 'Quantity Under';
      } else if (this.selectedIssueType === 'ZSC_OO3' || this.selectedIssueType === 'ZSC_OS3') {
        return 'Quantity Over';
      } else if (this.selectedIssueType === 'ZSC_NPPS3') {
        return 'Quantity';
      } else if (this.selectedCaseType === 'ZSC2_L2_PDA') {
        return 'Quantity Damage';
      }
    }
    return 'Quantity';
  }

  fetchOptions(query: string): Observable<any> {
    if (!query) {
      return of([]); // Return empty array if query is empty
    }
    // Replace with your actual API endpoint
    const skuSuggestionurl =
      this.endPointService.buildUrl(KNBR_GET_SKU_SUGGESTIONS_TO_CREATE_CASE(this.customerId)) + `?searchTerm=${query}`;
    return this.http.get<any>(skuSuggestionurl).pipe(map((response) => response.products || []));
  }

  openClaimForm(event) {
    this.caseCreationForm.controls.fileFreightClaim.setValue(event.target.checked);
    this.showClaimForm = !this.showClaimForm;
    let invoiceNumberSelected;
    if (this.caseFromInvoice) {
      invoiceNumberSelected = this.invoiceUrlObject?.documentNumber;
    } else {
      invoiceNumberSelected = this.helperForm.get('orderBaseDocumentNumber').value;
    }

    if (event.target.checked) {
      this.freightClaimApiToPrepopulateForm(invoiceNumberSelected);
    } else {
      this.clearOutClaimFormFields()
    }
  }

  clearOutClaimFormFields() {
      this.caseCreationForm.patchValue({
        Plant: null,
        ShipDate: null,
        CarrierName: null,
        CarrierNumber: null,
        DestCity: null,
        DestState: null,
        DestZipcode: null,
        claimAmount: null,
      });
  }

  freightClaimApiToPrepopulateForm(invoiceNumberSelected) {
    const frieghtClaimUrl = this.endPointService.buildUrl(KNBR_GET_FREIGHT_CLAIM_DETAILS(this.customerId), {
      queryParams: { invNumber: invoiceNumberSelected },
    });
    this.allApiSubscriptions.add(
      this.http.get(frieghtClaimUrl).subscribe((response: any) => {
        if (response && response.length > 0) {
          const firstItem = response[0];

          this.caseCreationForm.patchValue({
            Plant: firstItem.Plant,
            ShipDate: firstItem.ShipDate ? this.convertToNgbDate(firstItem.ShipDate) : null,
            CarrierName: firstItem.CarrierName,
            CarrierNumber: firstItem.CarrierNumber,
            DestCity: firstItem.DestCity,
            DestState: firstItem.DestState,
            DestZipcode: firstItem.DestZipcode,
            claimAmount: firstItem.claimAmount,
          });

        }
      })
    );
  }

 convertToNgbDate(dateStr: string | null): any {
  if (!dateStr || dateStr.length !== 8) return null;

  return {
    year: Number(dateStr.substring(0, 4)),
    month: Number(dateStr.substring(4, 6)),
    day: Number(dateStr.substring(6, 8)),
  };
}


  ngOnDestroy(): void {
    this.allApiSubscriptions.unsubscribe();
    this.caseCreationForm.reset();
    this.disableAllFields();
    this.uploadedFileObjects = [];
    this.multipleSelectedProducts = [];
  }
}
